import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../hooks/redux';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { modalSlice } from '../../../../store/reducers/ModalSlice';
import { ButtonClassNames, ModalVariants } from '../../../../models/Common';
import { NoAccountsIcon } from '../../../commons/icons/NoAccounts';

export const NoConnectedAccounts: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;

  const handleAddAccount = () => {
    dispatch(openModal({ modalVariants: ModalVariants.LinkAccount }));
  };

  return (
    <div className="multi-account__no-account">
      <NoAccountsIcon className="icon-seagull" />
      <CustomMUIButton
        label={`${t('multiAccount.addAccount')} +`}
        handleClick={handleAddAccount}
        className={ButtonClassNames.SecondaryOutlined}
        isBold
      />
    </div>
  );
};
